import React from "react";
import './Header.css';

export default function Header(){
    return(
        <header className="main-header">
            <img src= {require("../images/meme_logo.png")} className="main-logo"/>
            <h2 className="main-heading">Meme Generator</h2>
            <h4 className="self-promo">Created with ❤️ by Harshil Jani</h4>
        </header>
    )
}